import { isIncludedIn } from 'remeda'
import { seasonsMap } from '@velasca/constants'
import type { SeasonID } from '@velasca/types'

/**
 * Determines if a given number is a valid seasonID.
 *
 * @param possibleSeasonId - A number that could be a seasonID.
 * @returns True if the snumber is a valid seasonID, false otherwise.
 */
export const isSeason = (possibleSeasonId: number): boolean => {
  const seasons: SeasonID[] = Object.values(seasonsMap)

  return isIncludedIn(possibleSeasonId, seasons)
}
